/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_plot_load_example = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Load example`)
};

const es_plot_load_example = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargar ejemplo`)
};

const de_plot_load_example = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beispiel laden`)
};

const nl_plot_load_example = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voorbeeld laden`)
};

const fr_plot_load_example = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Charger l'exemple`)
};

const it_plot_load_example = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carica esempio`)
};

const pt_br2_plot_load_example = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregar exemplo`)
};

const pt_plot_load_example = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregar exemplo`)
};

const ja_plot_load_example = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`例を読み込む`)
};

const zh_plot_load_example = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加载示例`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const plot_load_example = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.plot_load_example(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("plot_load_example", locale)
	if (locale === "en") return en_plot_load_example(inputs)
	if (locale === "es") return es_plot_load_example(inputs)
	if (locale === "de") return de_plot_load_example(inputs)
	if (locale === "nl") return nl_plot_load_example(inputs)
	if (locale === "fr") return fr_plot_load_example(inputs)
	if (locale === "it") return it_plot_load_example(inputs)
	if (locale === "pt-BR") return pt_br2_plot_load_example(inputs)
	if (locale === "pt") return pt_plot_load_example(inputs)
	if (locale === "ja") return ja_plot_load_example(inputs)
	return zh_plot_load_example(inputs)
};